export default "__VITE_ASSET__efbff8ec__"